var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dates_form"
  }, [_c('div', {
    staticClass: "input_container"
  }, [_c('label', [_vm._v("Start")]), _c('datetime', {
    staticClass: "date hover_border",
    attrs: {
      "type": "datetime",
      "min-datetime": _vm.startDateMin,
      "max-datetime": _vm.startDateMax
    },
    model: {
      value: _vm.localStart,
      callback: function callback($$v) {
        _vm.localStart = $$v;
      },
      expression: "localStart"
    }
  })], 1), _c('div', {
    staticClass: "input_container"
  }, [_c('label', [_vm._v("End")]), _c('datetime', {
    staticClass: "date hover_border",
    attrs: {
      "type": "datetime",
      "min-datetime": _vm.endDateMin,
      "max-datetime": _vm.endDateMax
    },
    model: {
      value: _vm.localEnd,
      callback: function callback($$v) {
        _vm.localEnd = $$v;
      },
      expression: "localEnd"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }